import React from 'react';
import { getBallotOptionLabel, getBallotOptionImage } from './VoteTypeUtils.js'

export const VoteRanked = ({ options, hasVoted, onOptionsUpdate, group }) => {
    const handleSelect = (event) => {
        // Selected id clicked
        const selectedId = parseInt(event.target.id)

        // Get value
        let selectedValue = event.target.value

        // Check for non digit values and blank
        if (selectedValue) {
            selectedValue = selectedValue.replace(/[^\d]+/g, '');
        }

        selectedValue = parseInt(selectedValue)

        // Clone the array
        const rankedOptions = [...options]

        // Count current selections (ignore updating an existing selection)
        let selectionCount = 0;
        for (let option of rankedOptions) {
            if (option.ballotOptionId !== selectedId && option.score > 0) {
                selectionCount++
            }
        }

        // Clone and update each one (only 1 can be ticked)
        for (let i = 0; i < rankedOptions.length; i++) {
            rankedOptions[i] = { ...rankedOptions[i] }
            if (rankedOptions[i].ballotOptionId === selectedId
                // Dont allow more rankings than max votes
                && selectionCount < group.maximumVotes
                // Dont allow a ranking value higher than the max vote (ignore null selectedValue when they delete an existing entry)
                && (!selectedValue || selectedValue <= group.maximumVotes)) {
                rankedOptions[i].score = parseInt(selectedValue)
            }
        }

        // Notify update
        onOptionsUpdate(rankedOptions)
    }

    return (
        <React.Fragment>
            {options.map((option) =>
                <div key={option.ballotOptionId} className={'mb-2 py-2 flex items-start ' + (option.isError ? "-mx-2 p-2 shadow-lg bg-red-100" : "")}>
                    {getBallotOptionImage(group, option)}
                    <input type="text" className="w-10 h-8 mr-4 px-2 text-center inline-block font-medium border-gray-300 rounded border-2"
                        id={option.ballotOptionId}
                        value={option.score ? option.score : ''}
                        disabled={hasVoted}
                        onChange={handleSelect} />
                    <label htmlFor={option.ballotOptionName}
                        className="flex-1">{getBallotOptionLabel(group, option)}</label>
                </div>
            )}
        </React.Fragment>
    );
}